import WithSeguimientoMonitoreoProvider from "./WithSeguimientoMonitoreoProvider";

const SeguimientoMonitoreoV2 = ()=>{
    return (<WithSeguimientoMonitoreoProvider soloUnidades={false} esSeguimientoMonitoreo={true}/>)
}
export default SeguimientoMonitoreoV2;